import { Circle, Database, Kanban, FileText, MessageSquare, Lock, Server, Terminal, Calendar, Mail, Network, FolderKanban } from 'lucide-react';

/**
 * Manifest icon names → lucide icons. Shared by the activity rail, the
 * Settings sidebar and the extension cards in Settings → Extensions; kept out
 * of ActivityBar.js so a card does not pull the whole rail into its graph.
 */
const EXTENSION_ICONS = { circle: Circle, database: Database, kanban: Kanban, 'file-text': FileText, 'message-square': MessageSquare, lock: Lock, server: Server, terminal: Terminal, calendar: Calendar, mail: Mail, network: Network, 'folder-kanban': FolderKanban };

export function resolveExtensionIcon(name) {
  return EXTENSION_ICONS[name] || Circle;
}

/** The icon an extension shows: its first rail entry's, else the manifest's own. */
export const iconOfManifest = (manifest) =>
  resolveExtensionIcon(manifest?.contributes?.activityBar?.[0]?.icon || manifest?.icon);
